import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router'
import store, { history } from './store';
import findIndex from 'lodash-es/findIndex';
import { IntlProvider, addLocaleData } from 'react-intl';
import localeEn from 'react-intl/locale-data/en';
import localeKo from 'react-intl/locale-data/ko';

// custom
import rootRoutes from 'routes/root.js';
import NotFound from 'components/error/NotFound';
import { VALID_LANGUAGES, DEFAULT_LANGUAGE, STORAGE_LANG_KEY } from 'util/constants';
import messagesForKo from 'locales/ko';
import messagesForEn from 'locales/en';

// 언어별 데이타 및 메세지 
addLocaleData([...localeKo, ...localeEn]);
const messages = {
    'ko': messagesForKo,
    'en': messagesForEn
};


// 해당 언어를 지원하는지 확인
const isValidLanguage = (target) => (
    findIndex(VALID_LANGUAGES, function(language) { return language === target; }) > -1
)


class Root extends Component {

    constructor(props) {
        super(props);
        // 언어정보 확인 (1. localStorage 정보 확인 / 2. 브라우저의 language정보 / 3. 기본값)
        let language = DEFAULT_LANGUAGE;
        if( localStorage.getItem(STORAGE_LANG_KEY) && isValidLanguage(localStorage.getItem(STORAGE_LANG_KEY)) ) {
            language = localStorage.getItem(STORAGE_LANG_KEY);
        } else {
            const navigatorLang = navigator.language.split(/[-_]/)[0];//region code없는 언어정보 
            if( isValidLanguage(language) ) {
                language = navigatorLang;
                localStorage.setItem(STORAGE_LANG_KEY, language);
            }
        }

        this.state = {
            lang: language,
        };
    }

    // 언어변경 처리
    changeLanguage = (language) => {
        localStorage.setItem(STORAGE_LANG_KEY, language);
        this.setState({ lang: language });
    }

    render() {
        const currentLanguage = this.state.lang;
        console.log("currentLanguage:",currentLanguage);
        
        return (
            <Provider store={store}>
                <IntlProvider
                    locale={currentLanguage}
                    messages={messages[currentLanguage]}
                >
                    <ConnectedRouter history={history}>
                        <Switch>
                            {rootRoutes.map( prop => {
                                if( prop.redirect ) {
                                    return <Redirect exact from={prop.path} to={prop.to} key={prop.id} />;
                                } else {
                                    return <Route exact={prop.exact} path={prop.path} component={prop.component} key={prop.id} />;
                                }
                            })}
                            <Route component={NotFound} />
                        </Switch>
                    </ConnectedRouter>
                </IntlProvider>
            </Provider>
        );
    }

}

export default Root;